import { ReactComponent as CrossIcon } from '@/assets/icons/editor/cross-times.svg'
import modalService from '@/services/modal.service'
import changelog from '@/changelog.json'
import './ChangelogModal.scoped.sass'

export const CHANGELOG_LAST_VIEWED_KEY = 'changelog_last_viewed_date'

export function markChangelogViewed () {
  if (changelog.length === 0) return
  window.localStorage.setItem(CHANGELOG_LAST_VIEWED_KEY, changelog[0].date)
}

export function hasUnreadChangelog () {
  if (changelog.length === 0) return false
  const lastSeen = window.localStorage.getItem(CHANGELOG_LAST_VIEWED_KEY)
  return lastSeen !== changelog[0].date
}

function formatDate (iso) {
  const [y, m, d] = iso.split('-').map(Number)
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString(undefined, {
    year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC'
  })
}

export default function ChangelogModal () {
  return (
    <div className='changelog-modal'>
      <div className='changelog-header'>
        <h2>What's new</h2>
        <div className='close-icon' onClick={() => modalService.close()}><CrossIcon/></div>
      </div>
      <div className='changelog-body'>
        {changelog.map((entry) => (
          <section key={entry.date} className='changelog-entry'>
            <div className='entry-date'>{formatDate(entry.date)}</div>
            <ul>
              {entry.changes.map((change, i) => (
                <li key={i} className={`change change-${change.type}`}>
                  <span className={`tag tag-${change.type}`}>{change.type}</span>
                  <span className='change-text'>{change.text}</span>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  )
}
